import { createAction } from "redux-actions";
import { GET_INSTITUTION_CORE } from "../constants";
import { feathersCreateData } from "../services";

export const getInstitutionCore = createAction(GET_INSTITUTION_CORE, (data) => feathersCreateData('core-server', {
    service: 'TRANSFERS',
    func: 'RETURN INFORMATION INSTITUTION',
    data
})())